import React from 'react';
import { X } from 'lucide-react';
import AnimateOnScroll from './AnimateOnScroll';
import { positioningSection } from '../content/landingContent';

export const PositioningSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-stone-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-slate-100 rounded-full opacity-30 blur-3xl"></div>
      
      <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10">
        <AnimateOnScroll>
          <div className="text-center space-y-8">
            <div className="inline-flex items-center justify-center space-x-3 px-6 py-3 rounded-full bg-white border border-stone-200 shadow-sm">
              <X className="w-5 h-5 text-stone-600" />
              <span className="text-sm font-medium text-stone-700 uppercase tracking-wide">{positioningSection.badge}</span>
            </div>
            <h2 className="text-4xl font-bold text-stone-900 tracking-tight">
              {positioningSection.headline}
            </h2>
            <div className="max-w-2xl mx-auto space-y-6">
              {positioningSection.paragraphs.map((paragraph, index) => (
                <p key={index} className="text-lg text-stone-600 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
};

export default PositioningSection;